import React from 'react';
import "./Comment.scss";

const Comment = ({ image, name, occupation, valoration, text }) => {
    return (
        <div className="comment">
            <div className="comment__header">
                <div className="comment__image-container">
                    <img src={image} alt={name} />
                </div>
            </div>
            <div className="comment__body">
                <div className="comment__description">
                    "{text}"
                </div>
                <div className="comment__data">
                    <span className="comment__author">{name}, {occupation}</span>
                    <span className="card__stars">
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Comment;
